import { hotelCrudConfig } from '@/config/objects/hotels';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Hotels list page
 */
export function HotelsPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Hotels', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView config={hotelCrudConfig} baseUrl="/hotels" breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
